import axios from "axios"

export default function toPdf(config, updateProgress) {
  let javascript = false
  if (config.javascript) javascript = true
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: "https://docraptor.com/docs",
      headers: {
        "Content-Type": "application/json"
      },
      responseType: "blob",
      data: {
        user_credentials: `${import.meta.env["VITE_DOC_RAPTOR_API_KEY"]}`,
        doc: {
          document_content: config.document,
          type: "pdf",
          javascript: true,
          test: ["mp-ready-staging", "mp-ready-pre-production"].includes(
            import.meta.env["VITE_PROJECT_ID"]
          )
        }
      },
      onDownloadProgress: updateProgress
    })
      .then(res => {
        const file = new Blob([res.data], { type: "application/pdf" })
        const url = URL.createObjectURL(file)
        resolve({ url: url, blob: file })
      })
      .catch(err => reject(err))
  })
}
